import api from "@/shared/services/apiClient";
import type { NotificationHistoryItem } from "@/features/notifications/types/notification";

export const notificationHistoryService = {
  getMyNotifications: async (): Promise<NotificationHistoryItem[]> => {
    const response = await api.get("/notifications");
    return response.data;
  },

  markAsRead: async (notificationId: string) => {
    const response = await api.patch(`/notifications/${notificationId}/read`);
    return response.data;
  },

  saveTokenToBackend: async (token: string) => {
    const response = await api.post("/notifications/token", { expoPushToken: token });
    return response.data;
  },
};
